<template>
  <message-box
    v-if="displayEditRequestTextBox"
    title="Edit request text"
    submit-text="Update request text"
    type="orange"
    :disable-submit="!!request.request_text ? false : true"
    @on-close="setDisplayEditRequestTextBox(false)"
    @on-cancel="setDisplayEditRequestTextBox(false)"
    @on-submit="handleSubmit"
  >
    <div class="message-contents-field">
      <NrFormLabel>Request text</NrFormLabel>
      <nr-editor
        :modelValue="request.request_text"
        @update:modelValue="updateRequestText"
        :resizable="false"
        :placeholder="'Type request text here.'"
        :rows="10"
        strike
        bulletList
        orderedList
        link
      />
      <p class="is-size-7 m-bottom-12">
        This updated request text will be visible to the requester and changes
        will post to the request timeline.
      </p>
    </div>
  </message-box>
</template>

<script lang="ts">
import MessageBox from '@nextrequestco/components/src/components/MessageBox'
import NrFormLabel from '@nextrequestco/components/src/components/form-elements'
import NrEditor from '@nextrequestco/components/src/components/NrEditor'
import NrSentry from '../../../../utils/nr_sentry'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'RequestTextModal',
  components: { MessageBox, 'nr-editor': NrEditor, NrFormLabel },
  data() {
    return {
      requestText: ''
    }
  },
  computed: {
    ...mapState('request_show', [
      'displayEditRequestTextBox',
      'currentAction',
      'request'
    ])
  },

  methods: {
    ...mapActions('request_show', [
      'setDisplayEditRequestTextBox',
      'updateRequest',
      'fetchTimeline'
    ]),

    updateRequestText(value: string): void {
      this.requestText = value
    },

    handleSubmit(): void {
      this.updateRequest({
        request_id: this.request.pretty_id,
        request_text: this.requestText
      })
        .then(() => {
          this.fetchTimeline({
            pretty_id: this.request.pretty_id
          })
          this.setDisplayEditRequestTextBox(false)
          this.$toasted.success('Request text updated successfully')
        })
        .catch((e) => {
          this.$toasted.error('There was an error updating the request')
          NrSentry.captureError(e)
        })
    }
  }
}
</script>

<style lang="scss">
.message-box {
  .message-contents-field,
  .editor-field {
    display: flex;
    flex-direction: column;
    flex: 0 1 100%;
  }

  .nr-editor {
    flex: 1 1 auto;
  }
}
</style>
